import React, {Component} from 'react';
import {gpn} from "../GPN"
import req from "../req";
import Logo from "../assets/images/logo.png";
import AdminSignature from "../assets/images/admin-signature.png";

class PrintContract extends Component {

    state = {
        id: this.props.params.id,
        fullName: "",
        signature: "",
        nationalCode: "",
        fatherName: "",
        birthDate: "",
        shenasnameh: "",
        postalCode: "",
        sokoonat: "",
        address: "",
        phone: "",
        elatMorajeeh: "",
        nahveAshnayei: "",
    };

    componentDidMount() {
        this.getContract();
    }

    getContract() {
        req.get(`/user/contract?id=${this.state.id}`)
            .then(r => {
                this.setState({...r});
            })
            .catch(err => {
                console.error(err);
            });
    }

    render() {
        let {fullName, nationalCode, phone} = this.state;
        return (
            <div className="print-contract">
                <div className="head">
                    <div className="row justify-content-center">
                        <div className="col-auto">
                            <div className="logo">
                                <img src={Logo} alt=""/>
                            </div>
                        </div>
                        <div className="col">
                            <div className="company">
                                <h1>شرکت مهراندیشه تکین آنوش</h1>
                                <h1>شماره ثبت: 13536</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content">
                    <h1>توافق نامه</h1>
                    این توافق نامه فی مابین شرکت <b>مهراندیشه تکین آنوش</b> به شناسه ملی <b>۱۴۰۰۸۶۸۸۹۴۲</b> به نمایندگی
                    آقای غلامحسین رجبی وردنجانی مدیرعامل و رئیس هیئت مدیره شرکت به عنوان
                    تامین
                    کننده کالا
                    (فروشنده) که از این به بعد در این توافق نامه <b>طرف اول</b> نامیده می شود
                    و آقا/خانم
                    <b>&nbsp;{fullName}&nbsp;</b> به
                    کد ملی <b>&nbsp;{nationalCode}&nbsp;</b> شماره تماس <b>&nbsp;{phone}&nbsp;</b>
                    به
                    عنوان متقاضی دریافت تسهیلات و وام که از این به بعد در این توافق نامه <b>طرف دوم</b> نامیده می
                    شود با
                    الزام
                    و آگاهی و رعایت موارد ذیل منعقد می گردد:
                    <br/>
                    <h3>ماده یکم:</h3>
                    <p className="made">طرف دوم توافق نامه با علم و آگاهی کامل نسبت به شرایط، ضوابط، مدارک لازم، پیش
                        پرداخت نقدی و ......... اقدام به دریافت تسهیلات و وام نموده است. </p>
                    <h4>تبصره:</h4>
                    <div className="made">در طرح های دارای اپلیکیشن طرف دوم با پذیرفتن شرایط اقدام به ثبت نام و تکمیل
                        فرآیند می نماید.
                    </div>
                    <h3>ماده دوم:</h3>
                    <p className="made">پرداخت هزینه های اولیه برابر نرخ های تعیین شده از طریق درگاه پرداخت توسط طرف دوم
                        صورت می پذیرد.</p>
                    <h3>تبصره مهم:</h3>
                    <p className="made">چنانچه طرف دوم در هر مرحله از مراحل درخواست تسهیلات به هر دلیلی از انجام ادامه
                        روند انصراف دهد و یا به دلیل عدم احراز شرایط و تکمیل و ارائه مدارک لازم درخواست تسهیلات خرید
                        کالای وی رد گردد، امکان مسترد نمودن هزینه های ثبت نام و جاری وجود نخواهد داشت و کلاً پرداخت
                        هزینه ثبت نام تضمینی برای دریافت تسهیلات نمی باشد. </p>
                    <h3>ماده سوم:</h3>
                    <p className="made">طرف دوم متعهد می گردد که هر گونه پیامک یا اعلانی که از سمت تأمین کننده مالی در
                        طرح برای وی ارسال گردید را به قید فوریت به طرف اول اعلام و ارسال نماید. لازم به ذکر است که عدم
                        اطلاع رسانی مورد فوق توسط طرف دوم که باعث اخلال در روند دریافت تسهیلات گردد مسئولیتی را برای طرف
                        اول ایجاد نخواهد نمود. </p>
                    <br/>
                    {this.renderSignature()}
                    <br/>
                    <br/>
                    <div className="page-num">صفحه 1 از 2</div>
                    <br/>
                    <br/>

                    <h3>ماده چهارم:</h3>
                    <p className="made">دریافت تسهیلات، وام وخرید کالا و دریافت نمودن کالا بستگی به نوع طرح و
                        پلتفرم دارد و با توجه به حجم بالای پرونده ها سه الی پنج هفته بعد از تایید نهایی و تحویل مدارک و
                        تضامین خواهد بود لازم به ذکر است
                        که عدم همکاری طرف دوم در تحویل به موقع مدارک و تضامین اعلام شده موجب افزایش زمان اعلامی بوده که
                        در اینصورت هیچگونه مسئولیتی متوجه طرف اول نمی باشد. </p>
                    <h4>تبصره:</h4>
                    <p className="made">متقاضی مدنظر داشته باشد با توجه به حجم بالای سفارشات احتمال سررسید اولین قسط قبل
                        از تحویل کالا و وام و تسهیلات متصور می باشد و می بایست نسبت به پرداخت قسط اول نیز اقدام نماید و
                        حق هرگونه
                        اعتراضی را از خود سلب و ساقط می نماید.</p>

                    <h3>ماده پنجم:</h3>
                    <p className="made">طرف دوم موظف می باشد که فاکتور و گواهی تحویل گرفتن کالای خود را به صورت دقیق
                        مطالعه، تکمیل و با امضاء و اثر انگشت واضح به طرف اول تحویل نماید و کالای دریافتی را کاملاً بررسی
                        و تحویل گیرد. </p>
                    <h3>ماده ششم:</h3>
                    <p className="made">خریدار ضمن پذیرش و مسئولیت انتخاب و تحویل کالاهای موضوع قرارداد متعهد گردید
                        کالاها یا کالاهای مذکور را در طول مدت قرارداد شخصا مصرف نموده و تا زمان تسویه اقساط بصورت امانت
                        نزد خریدار باقی می ماند حفظ و نگهداری از کالاها به عهده خریدار می باشد. </p>
                    <h3>ماده هفتم:</h3>
                    <p className="made">اسقاط خيارات: خریدار با علم و اطلاع کامل از شرایط مفاد و تعهدات توافق اقدام به
                        انعقاد آن نموده و ضمن عقد خارج لازم کليه خيارات بخصوص خيار غبن فاحش بل افحش را که شفاها بين
                        طرفين مبادله گردیده از خود سلب و ساقط نموده است. </p>
                    <h3>ماده هشتم:</h3>
                    <p className="made">طرف دوم اقرار می نماید که از کم و کیف و اوصاف مورد معامله و تسهیلات و تعداد
                        اقساط هزینه ها ، پیش پرداخت تعداد چکهای پرداخت اقساط و تضامین و غیره اطلاع کامل و کافی دارد و به
                        هیچ عنوان موضوع مبهم و مجهولی در این موارد برای وی وجود ندارد. </p>
                    <h3>ماده نهم:</h3>
                    <p className="made">طرف دوم با مطالعه دقیق و کامل اسناد و مدارک و فرمهای ثبت نام اولیه و کلیه شرایط
                        ضوابط و قوانین شرکت مهراندیشه تکین آنوش را پذیرفته و با طیب خاطر و رضای کامل و از روی میل و
                        اختیار و بدون اکراه و اجبار اقدام به درخواست تسهیلات و تشکیل پرونده نموده اند.
                        این توافق نامه در دو صفحه، نه ماده و یک تبصره پس از مطالعه و با امضاء طرفین نافذ می باشد که در
                        یک نسخه تنظیم گردید .
                    </p>

                    <br/>
                    {this.renderSignature()}

                    <br/>
                    <div className="page-num">صفحه 2 از 2</div>
                </div>


            </div>
        );
    }

    renderSignature() {
        let {signature, fullName} = this.state;
        return (
            <div className="signatures">
                <div className="row justify-content-center">
                    <div className="col-auto">
                        <div className="signature">
                            <img src={signature} alt=""/>
                            <p className="full-name" style={{textAlign: "center"}}>{fullName}&nbsp; (طرف دوم)</p>
                        </div>
                    </div>
                    <div className="col-auto">
                        <div className="signature-admin">
                            <img src={AdminSignature} alt=""/>
                            <p className="full-name" style={{textAlign: "center"}}>غلامحسین رجبی وردنجانی (طرف اول)</p>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

export default gpn(PrintContract);